export default __webpack_public_path__ + "assets/Lato-ThinItalic.42a616fcfc8a08caef71f3deb0095fcc.ttf";